import {
  type Classroom,
  DEFAULT_CLASS_DUTIES,
  DEFAULT_HOMEROOM_SUBJECTS,
  type Student,
  studentNumberLabel,
} from "@classroom/domain";
import { i18n } from "../i18n";
import type { RecordReport } from "./recordExports";

// Use the visible draft rather than stored assignments, which may still be saving.
export function buildStudentDutyReport(
  classroom: Classroom,
  students: Student[],
  assignments: Record<string, string>,
): RecordReport {
  const names = new Map(
    students
      .filter(
        (student) =>
          student.workspaceId === classroom.workspaceId &&
          student.classId === (classroom.sharedDataClassId || classroom.id) &&
          student.active,
      )
      .map((student) => [student.id, `${studentNumberLabel(student)} ${student.name}`]),
  );
  const name = (studentId?: string) =>
    studentId
      ? names.get(studentId) || i18n.t("reportLabels:removedStudent")
      : i18n.t("screenCopy:teacherConsole.notAssigned");
  const subjects = [...new Set([...DEFAULT_HOMEROOM_SUBJECTS, ...(classroom.customSubjects || [])])];
  const duties = [...new Set([...DEFAULT_CLASS_DUTIES, ...(classroom.customDuties || [])])];
  return {
    title: i18n.t("marketing:dutiesTab"),
    className: classroom.name,
    sheets: [
      {
        title: i18n.t("screenCopy:teacherConsole.subjectRepresentatives"),
        headers: [i18n.t("interfaceExtras:subject"), i18n.t("reportLabels:classNumberAndName")],
        rows: subjects.map((subject) => {
          const monitors = [assignments[`科長｜${subject}`], assignments[`科長｜${subject}｜二`]].filter(Boolean);
          return [subject, monitors.length ? [...new Set(monitors)].map(name).join("\n") : name()];
        }),
      },
      {
        title: i18n.t("screenCopy:teacherConsole.otherDuties"),
        headers: [i18n.t("interfaceExtras:duty"), i18n.t("reportLabels:classNumberAndName")],
        rows: duties.map((duty) => [duty, name(assignments[duty])]),
      },
    ],
  };
}
